import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '@insite-store360/services';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const storageService = inject(StorageService);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            // Handle 401 Unauthorized errors (JWT expired or invalid)
            if (error.status === 401) {
                const isPublicLiveQuizRequest = req.url.includes('publicLiveQuiz');
                const onLiveQuizRoute = router.url.includes('liveQuiz');
                if (isPublicLiveQuizRequest || onLiveQuizRoute) {
                    return throwError(() => error);
                }

                // Same rule for the public dealer registration page: its
                // visitor has no account, so bouncing them to the login screen
                // turns a recoverable error into a dead end. The page shows the
                // failure itself instead.
                //
                // Matched on the route PREFIX, not `includes` — the admin
                // screens live under /admin/e-warranty/* and must keep the
                // normal 401 handling.
                if (router.url.startsWith('/e-warranty/dealer-registration')) {
                    return throwError(() => error);
                }

                // Already on the login screen — avoid re-entrant navigations.
                const currentUrl = router.url.split('?')[0];
                const onLoginRoute =
                    currentUrl === '/' ||
                    currentUrl === '' ||
                    currentUrl.endsWith('/login');

                // Clear host auth keys together so LoginGuard / SPFT token
                // resolution cannot disagree and bounce landing ↔ SPFT.
                storageService.deletedata('auth-token');
                localStorage.removeItem('accessToken');

                if (
                    !onLoginRoute &&
                    currentUrl &&
                    currentUrl !== '/'
                ) {
                    localStorage.setItem('redirectUrl', router.url);
                }

                if (!onLoginRoute) {
                    // Host login route is `/` (LoginGuard lives there).
                    void router.navigateByUrl('/');
                }
            }

            // Re-throw the error so other error handlers can process it
            return throwError(() => error);
        })
    );
};
